import GLPostingDetails from '../../components/details/GLPostingDetails';

const OpenTab = () => <GLPostingDetails isEmbedded />;

export default OpenTab;
